import { Icon, PopOver } from "components/common"
import { Col, List, Row, notification } from "antd"
import SenderReceiver from "components/common/senderReceiver/senderReceiver"
import { joinBytItems, localisedValue } from "utils"
import { useLazyGetCurrentLeadSharingQuery } from "features/clients/detail/api"
import { useState, useMemo } from "react"
import { t } from "i18next"

notification.config({
  maxCount: 1,
})

const ViewSharingDetail = lead => {
  const [fetchData, { data, isFetching }] = useLazyGetCurrentLeadSharingQuery()
  const [isPopOverVisible, setIsPopOverVisible] = useState(false)

  const showNotification = (message, description) => {
    notification.error({
      message: t(message),
      description: t(description),
    })
  }

  const getSharingList = useMemo(() => {
    return [
      ...(data?.[lead?.leadId]?.mortgage?.length > 0
        ? data?.[lead?.leadId]?.mortgage?.map(item => {
            return {
              sharedWith: t("Mortgage"),
              date: item?.dateTime,
              data: [
                [t("Purpose"), localisedValue({ object: item?.sharingPurpose, key: "title" })],
                [
                  t("By"),
                  joinBytItems(
                    [`${item?.sharedBy?.name} (${item?.sharedBy?.UserDesignation?.short})`, item?.sharedBy?.cell],
                    " | "
                  ),
                ],
                [
                  t("To"),
                  joinBytItems(
                    [
                      `${item?.sharedWith?.name}  ${
                        item?.sharedWith?.UserDesignation?.short && `( ${item?.sharedWith?.UserDesignation?.short})`
                      }  `,
                      item?.sharedWith?.cell,
                    ],
                    " | "
                  ),
                ],
              ],
            }
          })
        : []),
      ...(data?.[lead?.leadId]?.sales?.length > 0
        ? data?.[lead?.leadId]?.sales?.map(item => {
            return {
              sharedWith: t("Sale"),
              date: item?.dateTime,
              data: [
                [t("Purpose"), localisedValue({ object: item?.sharingPurpose, key: "title" })],
                [t("Commission"), item?.commission && `${item.commission}%`],
                [
                  t("By"),
                  joinBytItems(
                    [`${item?.sharedBy?.name} (${item?.sharedBy?.UserDesignation?.short})`, item?.sharedBy?.cell],
                    " | "
                  ),
                ],
                [
                  t("To"),
                  joinBytItems(
                    [
                      `${item?.sharedWith?.name}  ${
                        item?.sharedWith?.UserDesignation?.short && `( ${item?.sharedWith?.UserDesignation?.short})`
                      }  `,
                      item?.sharedWith?.cell,
                    ],
                    " | "
                  ),
                ],
              ],
            }
          })
        : []),
      ...(data?.[lead?.leadId]?.support?.length > 0
        ? data?.[lead?.leadId]?.support?.map(item => {
            return {
              sharedWith: t("Support"),
              date: item?.dateTime,
              data: [
                [t("Purpose"), localisedValue({ object: item?.sharingPurpose, key: "title" })],
                [
                  t("By"),
                  joinBytItems(
                    [`${item?.sharedBy?.name} (${item?.sharedBy?.UserDesignation?.short})`],
                    <Icon icon="GoDotFill" size=".7em" color="#000000" />
                  ),
                ],
                [
                  t("To"),
                  joinBytItems(
                    [
                      `${item?.sharedWith?.name}  ${
                        item?.sharedWith?.UserDesignation?.short ? `( ${item?.sharedWith?.UserDesignation?.short})` : ""
                      }  `,
                      item?.sharedWith?.cell,
                    ],
                    <Icon icon="GoDotFill" size=".7em" color="#000000" />
                  ),
                ],
              ],
            }
          })
        : []),
    ]
  }, [data, lead?.leadId])

  return (
    <PopOver
      trigger="click"
      visible={isPopOverVisible && !isFetching}
      onVisibleChange={visible => {
        const salesData = data?.[lead?.leadId]?.sales || []
        const supportData = data?.[lead?.leadId]?.support || []
        const mortgageData = data?.[lead?.leadId]?.mortgage || []
        if (salesData?.length === 0 || supportData?.length === 0 || mortgageData?.length === 0) {
          setIsPopOverVisible(false)
        } else {
          setIsPopOverVisible(visible)
        }
      }}
      content={getSharingList?.map(e => (
        <>
          <SenderReceiver
            sender={t("Lead Shared With")}
            icon="IconDoubleArrowRight"
            receiver={`${e?.sharedWith}`}
            date={e?.date}
            style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
          />
          <List
            loading={isFetching}
            size="small"
            dataSource={e?.data}
            renderItem={item => (
              <List.Item>
                <Row justify={"space-between"} className="w-100" gutter={16}>
                  <Col span={4}>
                    <div className="gray-700">{item[0]}</div>
                  </Col>
                  <Col span={20} align="right">
                    {item[1]}
                  </Col>
                </Row>
              </List.Item>
            )}
          />
        </>
      ))}
      overlayInnerStyle={{ width: 350 }}
    >
      <Icon
        hasBackground
        icon="BsShare"
        color="#707070"
        size="18px"
        style={{ margin: -7, padding: 3 }}
        className="pointer"
        iconContainerStyle={{ translate: "0 3px" }}
        onClick={e => {
          e.stopPropagation()
          fetchData(lead.leadId)
            .unwrap()
            .then(responseData => {
              const leadData = responseData?.[lead?.leadId]
              if (leadData?.sales?.length > 0 || leadData?.support?.length > 0 || leadData?.mortgage?.length > 0) {
                setIsPopOverVisible(true)
              } else {
                setIsPopOverVisible(false)
                showNotification(t("No Data Found"), t("No sharing data available for this lead."))
              }
            })
            .catch(() => {
              setIsPopOverVisible(false)
              showNotification(
                t("Something Went Wrong!"),
                t("Unable to fetch data. Please check your internet connection and try again.")
              )
            })
        }}
      />
    </PopOver>
  )
}

export default ViewSharingDetail
